import React from "react";

/* eslint-disable @typescript-eslint/ban-types */
interface EduProps {
  degree: string;
  school: string;
  start_time: string;
  end_time: string;
  index: number;
  deleteRow: Function | undefined;
}
/* eslint-enable @typescript-eslint/ban-types */

const EducationDisplay: React.FC<EduProps> = ({
  degree,
  school,
  start_time,
  end_time,
  index,
  deleteRow,
}) => {
  const buttonClick = () => {
    if (deleteRow != undefined) {
      deleteRow();
    }
  };

  return (
    <div className="mb-6 ml-2">
      <div className="mt-4 flex flex-row">
        <p className="text-light text-lg lg:text-xl">Education {index}</p>
        {deleteRow != undefined && (
          <button
            className="text-orange ml-auto mr-4 text-right text-lg lg:text-xl"
            onClick={buttonClick}
          >
            X
          </button>
        )}
      </div>

      <div className="mt-4 flex flex-row">
        <p className="text-orange ml-auto text-right text-lg lg:text-xl">
          {degree}
        </p>
      </div>

      <div className="mt-4 flex flex-row">
        <p className="text-blue ml-auto text-right text-lg lg:text-xl">
          {school}
        </p>
      </div>

      {(start_time.length > 0 || end_time.length > 0) && (
        <div className="flex flex-row">
          <p className="text-light mt-4 text-lg lg:text-xl">
            {start_time} - {end_time}
          </p>
        </div>
      )}

      <hr className="mx-auto my-2 h-1 w-4/5 rounded border-0 bg-[#333333] md:my-4" />
    </div>
  );
};

export default EducationDisplay;
